// @flow
import React from 'react';
import Grid, { GridProps } from '@material-ui/core/Grid';
import { When } from 'UI/components/atoms';
import FPActionButton from 'UI/components/atoms/FPActionButton';
import SaveButton from 'UI/components/atoms/SaveButton';
import FPButtonMenu from 'UI/components/molecules/FPButtonMenu';
import FPToggleButton from 'UI/components/molecules/FPToggleButton';

import { useStyles } from './styles';

type FPButtonBuilderProps = {
  buttonDefinitions: Array<Object>,
  GridContainerProps: GridProps
};

const MODES = {
  default: FPActionButton,
  save: SaveButton,
  menu: FPButtonMenu,
  toggle: FPToggleButton
};

const FPButtonBuilder = ({ buttonDefinitions, GridContainerProps }: FPButtonBuilderProps) => {
  const classes = useStyles();
  return (
    <Grid container {...GridContainerProps}>
      {buttonDefinitions.map(item => {
        const { props, mode = 'default', GridItemProps, visible = true } = item;
        const ButtonComp = MODES[mode] ?? FPActionButton;

        return (
          <When key={`${mode}${props?.text}`} condition={visible}>
            <Grid
              item
              className={classes.grid}
              aria-label={`${props?.text} container`}
              role="group"
              {...GridItemProps}
            >
              <ButtonComp {...props} />
            </Grid>
          </When>
        );
      })}
    </Grid>
  );
};
export default FPButtonBuilder;
